import { NewsWrapper } from "../../../../src/collections/news/News.style.js";
import serviceMeshAbstractions from "../../../../src/collections/news/2020/2020-12-02-kubecon+cloudnativecon-service-mesh-battle-stories-and-fixes/service-mesh-abstractions.webp";
import serviceMeshPerformance from "../../../../src/collections/news/2020/2020-12-02-kubecon+cloudnativecon-service-mesh-battle-stories-and-fixes/service-mesh-performance.webp";
import * as React from 'react';
export default {
  NewsWrapper,
  serviceMeshAbstractions,
  serviceMeshPerformance,
  React
};